import { useRef, useState } from "react";
import CheckIcon from "@mui/icons-material/Check";
import EditIcon from "@mui/icons-material/Edit";
import DSBox from "../../views/system-design/DSBox";
import DSTextField from "../../views/system-design/DSTextField";
import DSTypography from "../../views/system-design/DSTypography";
import DSIconButton from "../../views/system-design/DSIconButton";
import DSCircularProgress from "../../views/system-design/DSCircularProgress";

const Editable = (props: {
  title: string;
  default: string;
  onSet: (value: string) => Promise<any>;
  editIcon?: any;
  viewAs?: any;
}) => {
  const [active, setActive] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const val = useRef(props.default);
  return (
    <DSBox sx={{ display: "flex", alignItems: "center" }}>
      {active ? (
        <DSBox sx={{ display: "flex", flexDirection: "column" }}>
          <DSTextField
            size="small"
            onClick={(e) => e.stopPropagation()}
            onChange={(e) => {
              val.current = e.target.value;
            }}
            defaultValue={props.default}
          />
        </DSBox>
      ) : props.viewAs ? (
        props.viewAs
      ) : (
        <DSTypography>{val.current}</DSTypography>
      )}
      {error && (
        <DSTypography sx={{ fontSize: 12, color: "error.main" }}>
          {error}
        </DSTypography>
      )}
      {active ? (
        <DSIconButton
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            setError("");
            setActive(false);
            setLoading(true);
            props
              .onSet(val.current)
              .catch((e) => {
                setError(e.toLocaleString());
                console.log(e);
              })
              .finally(() => setLoading(false));
          }}
        >
          <CheckIcon fontSize="small" />
        </DSIconButton>
      ) : loading ? (
        <DSCircularProgress size={20} />
      ) : props.editIcon ? (
        <DSBox
          onClick={(e) => {
            e.stopPropagation();
            setActive(true);
          }}
        >
          {props.editIcon}
        </DSBox>
      ) : (
        <DSIconButton
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            setActive(true);
          }}
        >
          <EditIcon fontSize="small" />
        </DSIconButton>
      )}
    </DSBox>
  );
};

export default Editable;
